import Repository from '../Repository'

const resource = "/wallets/accounts"

export default {
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
}